const API_URL = 'https://assets.zooaszoo.com';
const CAPTURES_URL = 'https://captures.zooaszoo.com';
const DESCRIPTION = "Amongst 8 billion souls, we found each other through serendipity in this cosmic isolation. Zoo is a place where different cultures mash together to form something new. We want to set new rules, speak our own language, experiment with processes, find beauty in chaos. With strong individual artistic positions, we come together to create our own world — one that's honest and true to the human experience, dark reality, the South, the youth and everything in between. Zoo is a creative outlet for us to seek meaning.";

export default {
  API_URL,
  CAPTURES_URL,
  DESCRIPTION
};
